import Profile from "features/profile/profile";

export default Profile
